// extracted by mini-css-extract-plugin
export var itemText = "NavElements-module--itemText--MY9+S";
export var listItem = "NavElements-module--listItem--Q9MNp";